import { render, staticRenderFns } from "./DepositConfirmation.vue?vue&type=template&id=98b137c2&scoped=true&"
import script from "./DepositConfirmation.vue?vue&type=script&lang=js&"
export * from "./DepositConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DepositConfirmation.vue?vue&type=style&index=0&id=98b137c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b137c2",
  null
  
)

export default component.exports